const API_PATH_DEVELOPMENT = 'development/';

export const DEVELOPER_CACHE_API = `${API_PATH_DEVELOPMENT}cache` as const;
export const DEVELOPER_HELP_CONTACT_API = `${API_PATH_DEVELOPMENT}help-contacts` as const;
export const DEVELOPER_DYNAMICS_LOG_API = `${API_PATH_DEVELOPMENT}dynamics-logs` as const;
export const DEVELOPER_CRON_API = `${API_PATH_DEVELOPMENT}cron` as const;

